export default __webpack_public_path__ + "static/media/angle-right-icon.a282d58b.svg";